// Action Types
export const STORE_NOTES_BATCH = '360SC_RIKUTEC/STORE_NOTES_BATCH';
export const CLEAR_NOTES_CACHE = '360SC_RIKUTEC/CLEAR_NOTES_CACHE';
export const SET_NOTES_LOADING = '360SC_RIKUTEC/SET_NOTES_LOADING';

// Action Interfaces
export interface StoreNotesBatchAction {
    readonly type: typeof STORE_NOTES_BATCH;
    payload: {
        cacheKey: string;
        notes: any[];
    };
}

export interface ClearNotesCacheAction {
    readonly type: typeof CLEAR_NOTES_CACHE;
    payload?: {
        cacheKey?: string;
    };
}

export interface SetNotesLoadingAction {
    readonly type: typeof SET_NOTES_LOADING;
    payload: {
        cacheKey: string;
        loading: boolean;
    };
}

// Action Creators
export const storeNotesBatch = {
    action: STORE_NOTES_BATCH,
    fn: (
        cacheKey: string,
        notes: any[]
    ): StoreNotesBatchAction => ({
        type: STORE_NOTES_BATCH,
        payload: {
            cacheKey,
            notes
        }
    })
};

export const clearNotesCache = {
    action: CLEAR_NOTES_CACHE,
    fn: (cacheKey?: string): ClearNotesCacheAction => ({
        type: CLEAR_NOTES_CACHE,
        payload: cacheKey ? { cacheKey } : undefined
    })
};

export const setNotesLoading = {
    action: SET_NOTES_LOADING,
    fn: (
        cacheKey: string,
        loading: boolean
    ): SetNotesLoadingAction => ({
        type: SET_NOTES_LOADING,
        payload: {
            cacheKey,
            loading
        }
    })
};

// Union type for all notes actions
export type NotesAction = 
    | StoreNotesBatchAction 
    | ClearNotesCacheAction 
    | SetNotesLoadingAction;

